import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import {initReactI18next} from "react-i18next";
import common_en from "./translations/en_US/translations.json";
import common_fr from "./translations/fr_FR/translations.json";
import help_fr from "./translations/fr_FR/help.json";

i18n
    // detect user language
    // learn more: https://github.com/i18next/i18next-browser-languageDetector
    .use(LanguageDetector)
    // pass the i18n instance to react-i18next.
    .use(initReactI18next)
    // init i18next
    .init({
        fallbackLng: 'fr',
        debug: false,
        interpolation: {
            escapeValue: false, // not needed for react
        },
        resources: {
            en: {
                common: common_en
            },
            fr: {
                common: common_fr,
                help: help_fr
            },
        },
    });

export default i18n;